const ProductPage = {
    selectors: {
        "parent": { selector: "#product-swatches", type: "single", scope: "document" },
        "qsBtn": { selector: "#questions-btn", type: "single", scope: "document" },
        "reviewsBtn": { selector: "#reviews-btn", type: "single", scope: "document" },
        "reviewsDiv": { selector: "#reviews-div", type: "single", scope: "document" },
        "qsDiv": { selector: "#questions-div", type: "single", scope: "document" },
        "reviewsLink": { selector: "#reviews-link", type: "single", scope: "document" },
        "reviewsSection": { selector: "#reviews-section", type: "single", scope: "document" },
        "addToCartBtn": { selector: ".add-to-cart-main", type: "single", scope: "document" },
        "warrantyLinks": { selector: ".warranty-icon, .warranty-text", type: "all", scope: "document" },
        "warrantyAccordion": { selector: ".warranty-accordion", type: "single", scope: "document" },
        "sizeChartBtn": { selector: "#size-chart-btn", type: "single", scope: "document" },
        "sizeChart": { selector: "#size-chart-modal", type: "single", scope: "document" },
        "shapeTabs": { selector: '.shape-tab', type: "all", scope: "document" },
        "shapeGuideBtn": { selector: "#shape-guide-btn", type: "single", scope: "document" },
        "shapeGuide": { selector: "#shape-guide-modal", type: "single", scope: "document" },
        "idInput": { selector: ".product-id-input", type: "single", scope: "parent" },
        "pricesMain": { selector: "#product-details .prices", type: "all", scope: "document" },
        "optSelectedCustom": { selector: ".customization-swatch .option-selected", type: "single", scope: "document" },
        "swatchesCustom": { selector: ".swatch-btn-Customizations", type: "all", scope: "document" },
        "productDetailsContainer": { selector: ".product-details", type: "single", scope: "document" },
        "productImgGallery": { selector: ".product-imgs-container", type: "single", scope: "document" },
        "productPhotos": { selector: ".product-img-gallery", type: "single", scope: "document" },
        "resourcesHeader": { selector: ".resources-header", type: "single", scope: "document" },
        "ymalHeader": { selector: ".ymal-header", type: "single", scope: "document" },
        "fbtSwatches": { selector: ".swatch-fbt", type: "all", scope: "document" },
        "quickAddFbt": { selector: ".quick-add", type: "all", scope: "document" },
        "fbtProductCards": { selector: ".fbt-product-card", type: "all", scope: "document" },
        "fbtSelects": { selector: ".swatch-btn-select", type: "all", scope: "document" },
        "minusBtns": { selector: ".minus", type: "all", scope: "parent" },
        "plusBtns": { selector: ".plus", type: "all", scope: "parent" },
        "thumbnails": { selector: ".thumbnails-inner", type: "single", scope: "document" },
        "selected":  { selector: ".selected-outer", type: "single", scope: "document" },
        "thumbnailImages": { selector: ".thumbnail", type: "all", scope: "document" },
        "allSwatches": { selector: ".swatch-btn", type: "all", scope: "parent" },
        "ogTitleWithShape": { selector: 'meta[property="og:title"]', type: "single", scope: "document" },
        "ogImage": { selector: 'meta[property="og:image"]', type: "single", scope: "document" },
        "ogImageSecureUrl": { selector: 'meta[property="og:image:secure_url"]', type: "single", scope: "document" },
        "behindProdAcc": { selector: '#behind-prod-acc', type: "single", scope: "document" },
        "featuresAcc": { selector: '#product-features-acc', type: "single", scope: "document" },
        "techSpecsAcc": { selector: '#tech-specs-acc', type: "single", scope: "document" },
        "detailsCareAcc": { selector: '#details-care-acc', type: "single", scope: "document" },
        "currentView": { selector: '.current-view', type: "single", scope: "document" },
        "productTitleH1": { selector: "h1.product-title", type: "single", scope: "document" },
        "closeBtns": { selector: ".pdp-modal .icon-close", type: "all", scope: "document" },
        "videoThumbs": { selector: ".video-thumbnail", type: "all", scope: "document" },
        "clothingDropdowns": { selector: ".accordion-container", type: "all", scope: "document" },
        "clothingDescH3": { selector: ".clothing-details-content h3", type: "single", scope: "document" },
        "productTopCols": { selector: ".product-top-cols", type: "single", scope: "document" },
        "modelInfo": { selector: ".model-info", type: "all", scope: "document" }
    },
  
    init: async function(handle, variantId, okendoId, productId, productType, retired) { 
        this.productType = productType;
        this.retired = retired;
        Utility.fetchEls(this.selectors, this);
        this.childIds = await Utility.fetchChildIds(handle);
        this.productData = await Utility.fetchProductDataAjax(handle, productType, this.childIds);
        this.productDetails = await Utility.fetchProductDetails(handle, variantId);
        const {productData, productDataView, modelInfo} = this;
      
        const shapeSwatch = document.querySelector('.swatch-btn-Shape.selected');
        if (shapeSwatch) {
          this.selectedShape = shapeSwatch.dataset.swatchValue;
        }
      
        await this.initUrl(variantId);
        this.initCarouselScrolling();
        if (!retired) {
          Shared.handleOutOfStock();
          if (productData.variants.length !== 1) {
            Shared.initSwatchesStock(productData);
            Shared.initCustomizations(false);
          }
        }
        
        this.updateReviewAggregate();
        this.modalBg = Shared.modalBg;
      
        const { fbtProductCards } = this;
        if (fbtProductCards.length) {
           fbtProductCards.forEach((card) => {
            const firstSwatch = card.querySelector('.selected');
            if (firstSwatch) {
              Shared.handleSwatchChange(firstSwatch, false, true);
            }
          });
        }
         
        this.initEventListeners();
        if (productData.title.includes('Pro Air')) {
            this.ampedProAirInit();
        }

        if (productType == 'Apparel' && window.innerWidth < 1200 && this.clothingDescH3) {
          const textBlock = this.clothingDescH3.closest('.text-block');
          textBlock.parentNode.insertBefore(this.clothingDescH3, textBlock);
        }

      if (window.innerWidth < 1200) {
        const desktopH1 = document.querySelector('h1.desktop');
        if (desktopH1) {
          desktopH1.remove();
        }
      } else {
        const mobileH1 = document.querySelector('h1.mobile');
        if (mobileH1) {
          mobileH1.remove();
        }
      }
    },
    
    initEventListeners: function() {
        const {
            addToCartBtn,
            seriesSwatches, 
            fixedOptions, 
            warrantyLinks, 
            warrantyAccordion, 
            allSwatches,
            productData,
            mediaIdMapping,
            fbtSwatches,
            quickAddFbt,
            fbtSelects,
            thumbnails,
            sizeChartBtn,
            sizeChart,
            productTitleH1,
            currentView,
            modalBg,
            shapeGuideBtn,
            shapeTabs,
            shapeGuide,
            closeBtns,
            videoThumbs,
            modelInfo,
            clothingDropdowns,
            productType
        } = this;

        // add to cart initial state and event listeners
        if (addToCartBtn) {
          addToCartBtn.disabled = false;
        }  

        if (quickAddFbt.length) {
          quickAddFbt.forEach((btn) => {
            btn.addEventListener('click', (event) => {
              btn.disabled = false;
              Cart.addToCart(event);
            });
          });
        }

        if (addToCartBtn) {
          addToCartBtn.addEventListener('click', (event) => {
            Cart.addToCart(event);
          });
        }
        
        if (currentView) {
          currentView.addEventListener('click', function() {
            productTitleH1.scrollIntoView({ behavior: 'smooth' });
          });
        }
        
        // scroll to warranty section on click
        if (warrantyLinks) {
          console.log('warranty links', warrantyLinks);
          warrantyLinks.forEach((link) => {
            link.addEventListener('click', function() {
              warrantyAccordion.scrollIntoView({ behavior: 'smooth' });
              // add this function into this script?
              togglefaqAccordion(4);
            });
          });
        }

        if (allSwatches.length) {
          // handle swatch change when swatch clicked
          allSwatches.forEach((swatch) => {
              swatch.addEventListener('click', () => {
                  Shared.handleSwatchChange(swatch);
              });
          });
        }

        if (fbtSwatches.length) {
          fbtSwatches.forEach((swatch) => {
            swatch.addEventListener('click', () => {
              Shared.handleSwatchChange(swatch, false, true);
            });
          });
        }
          
        if (fbtSelects.length) {
          fbtSelects.forEach((select) => {
            select.addEventListener('change', () => {
              Shared.handleSwatchChange(select, false, true);
            });
          });
        }
          
        this.initReviewsQsEventListeners();
        Shared.initQuantityEventListeners();
        
        if (sizeChartBtn) {
            sizeChartBtn.addEventListener('click', function() {
                modalBg.style.display = 'block';
                sizeChart.style.display = 'block';
            });
        }

        if (shapeGuideBtn) {
          if (window.innerWidth < 769) {
            this.updateShapeGuide();
          }
          window.addEventListener('resize', () => {
            if (window.innerWidth < 769) {
              this.updateShapeGuide();
            }
          });
          shapeGuideBtn.addEventListener('click', function() {
              modalBg.style.display = 'block';
              shapeGuide.style.visibility = 'visible';
          });
        }

        this.initTechSpecsScroll();

        if (closeBtns) {
            closeBtns.forEach((btn) => {
              btn.addEventListener('click', function(){
                  const modal = btn.closest('.pdp-modal');
                  if (modal.id == 'shape-guide-modal') {
                    modal.style.visibility = 'hidden';
                  } else {
                    modal.style.display = 'none';
                  }
                  if (!btn.classList.contains('grip-guide-close')) {
                    modalBg.style.display = 'none';
                  }
              });
            });
          }

      if (videoThumbs) {
        videoThumbs.forEach((element) => {
            element.addEventListener('click', () => {
                var videoId = element.getAttribute('data-video-id');
                var iframe = document.createElement('iframe');
                iframe.setAttribute('src', 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&mute=1');
                iframe.setAttribute('frameborder', '0');
                iframe.setAttribute('allowfullscreen', '');
                iframe.style.width = '100%';
                iframe.style.height = '100%';
                element.innerHTML = '';
                element.appendChild(iframe);
            });
        });
      }
      if (clothingDropdowns) {
        clothingDropdowns.forEach((dropdown) => {
          dropdown.addEventListener('click', () => {
            if (dropdown.classList.contains('expanded')) {
              dropdown.classList.remove('expanded');
            } else {
              dropdown.classList.add('expanded');
            }
          });
        });
      }
  },
  
    updateShapeGuide: function() {
        const {selectedShape, shapeTabs} = this;
        shapeTabs.forEach((tab) => {
          if (tab.dataset.shape == selectedShape) {
            tab.classList.add('active');
          } else {
            tab.classList.remove('active');
          }
        });
      },
    
    initReviewsQsEventListeners: function() {
        const {reviewsLink, reviewsBtn, qsBtn, reviewsDiv, qsDiv, reviewsSection} = this;
        // reviews/qs event listeners
        reviewsLink.addEventListener('click', function() {    
            reviewsSection.scrollIntoView({ behavior: 'smooth' });
          });

      if (reviewsBtn) {
        reviewsBtn.addEventListener('click', function() {
          reviewsDiv.style.display = 'block';
          qsDiv.style.display = 'none';
          reviewsBtn.classList.add('active-btn');
          qsBtn.classList.remove('active-btn');
        });
      }
        
        if (qsBtn) {
          qsBtn.addEventListener('click', function() {
            reviewsDiv.style.display = 'none';
            qsDiv.style.display = 'block';
            qsBtn.classList.add('active-btn');
            reviewsBtn.classList.remove('active-btn');
          });
        }
        
    },
    
    getVariantFromUrl: function() {
        const { productData } = this;
        const url = new URL(window.location.href);
        const urlParams = new URLSearchParams(url.search);
        const variantId = urlParams.get('variant');
        const variants = productData.variants;
        const isVariant = variants.find((variant) => variant.id == variantId);
        return isVariant;
    },
    
    initUrl: function(variantId) {
        const { productData } = this;
        const variant = this.getVariantFromUrl(productData);
        const url = new URL(window.location.href);
        if (variant && variant.title.includes('Custom')) {
            let variantTitle = variant.title.split(' / ');
            variantTitle = variantTitle.filter((part) => !part.includes('Custom'));
            const matchedVariant = productData.variants.find((productVariant) => {
                let productVariantTitleParts = productVariant.title.split(' / ');
                // Check if every part of variantTitle is included in productVariantTitleParts
                // and that 'Custom' is not included
                return variantTitle.every((part) => productVariantTitleParts.includes(part)) &&
                    !productVariantTitleParts.some((part) => part.includes('Custom'));
            });
            url.searchParams.set('variant', matchedVariant.id);
            window.history.pushState({ path: url.toString() }, '', url.toString());
            this.reinitIdsToNonCustom(matchedVariant);
        }
        else if (!variant) {
            url.searchParams.set('variant', variantId);
            window.history.pushState({ path: url.toString() }, '', url.toString());
        }
    },
    
    reinitIdsToNonCustom: function(variant) {
        // pdp needs to default to a non-customized variant
        const { addToCartBtn, idInput, pricesMain, optSelectedCustom, swatchesCustom } = this;
        
        idInput.value = variant.id;

        // addToCartBtn.textContent = 'Add To Cart - $' + (variant.price / 100).toFixed(2).replace(/\.00$/, '');
        pricesMain.forEach((price) => {
          price.innerHTML = variant.compare_at_price 
            ? `<span class="compare-price">$${(variant.compare_at_price / 100).toFixed(2).replace(/\.00$/, '')}</span><span class="price on-sale">$${(variant.price / 100).toFixed(2).replace(/\.00$/, '')}</span>` 
            : `<span class="price">$${(variant.price / 100).toFixed(2).replace(/\.00$/, '')}</span>`;
        });
        
        optSelectedCustom.textContent = 'None';

        swatchesCustom.forEach((swatch) => {
            swatch.classList.remove('selected');
            if (swatch.dataset.swatchValue === 'None') {
                swatch.classList.add('selected')
            }
        });
    },    

    initTechSpecsScroll: function() {
      const container = document.querySelector('#features-content');
      let scrollDistance = 400;
      const scrollDuration = 300;
        if (window.innerWidth < 476) {
          scrollDistance = 200;
        } else if (window.innerWidth < 571 && window.innerWidth > 475) {
          scrollDistance = 250;
        }

      const leftArrow = document.querySelector('.features-container .left-arrow');
      if (leftArrow) {
        leftArrow.addEventListener('click', () => {
          Utility.smoothScroll(container, -scrollDistance, scrollDuration);
        });
      }
      
      const rightArrow = document.querySelector('.features-container .right-arrow');
      if (rightArrow) {
        rightArrow.addEventListener('click', () => {
          Utility.smoothScroll(container, scrollDistance, scrollDuration);
        });
      }
    },
    
    initStickyProductDetails: function() {
          const {productDetailsContainer, productImgGallery, productPhotos, productTopCols} = this;
          const imgGalleryLeft = productImgGallery.getBoundingClientRect().left;
          const rect = productDetailsContainer.getBoundingClientRect();
          const leftPosition = rect.left + window.scrollX;
          const productDetailsWidth = rect.width;
  
          const header = document.querySelector('.header-nav');
          const nav = document.querySelector('#shopify-section-navigation');
          const navStyles = window.getComputedStyle(nav);
  
          if (window.innerWidth > 1200) {
              let threshold = navStyles.position == 'sticky' ? 98 : header.offsetHeight; // height of the nav + red header
              const productDetailsHeight = rect.height;
              const imgGalleryBottom = productImgGallery.getBoundingClientRect().height - window.innerHeight + threshold;
              const newBoundary = imgGalleryBottom + threshold + 24; // plus 4 for margin
            console.log('new boundary', newBoundary);
            console.log('product details height', productDetailsHeight);
            console.log('productTopCols', productTopCols);
                console.log('imgGalleryBottom', imgGalleryBottom);
            console.log('scroll Y', scrollY);
            console.log('threshold', threshold);
            const newTopValue = -(navStyles.position == 'sticky' ? (window.scrollY - newBoundary - header.offsetHeight) : (window.scrollY - newBoundary));
              
              // Check if we've scrolled past the threshold and the bottom of productShop is not yet visible
              if (window.scrollY > threshold && window.scrollY < newBoundary) {
                console.log('condition 1');
                  // Fix the element at the top when scrolling within the productShop
                  productDetailsContainer.style.position = 'fixed';
                  productDetailsContainer.style.top = navStyles.position == 'sticky' ? `${header.offsetHeight + 4}px` : '4px';
                  productDetailsContainer.style.bottom = '';
                  productImgGallery.style.left = imgGalleryLeft + 'px';
                  productDetailsContainer.style.width = productDetailsWidth + 'px';
                  productDetailsContainer.style.left = leftPosition + 'px';
              } else if (window.scrollY > threshold && window.scrollY >= newBoundary) {
                console.log('condition 2');
                  productDetailsContainer.style.position = 'fixed';
                  productDetailsContainer.style.top = newTopValue + 'px';
                  productImgGallery.style.left = imgGalleryLeft + 'px';
                  productDetailsContainer.style.width = productDetailsWidth + 'px';
                  productDetailsContainer.style.left = leftPosition + 'px';
                  productTopCols.style.height = productDetailsHeight + newBoundary + 'px';
              } else if (window.scrollY < threshold) {
                  // Reset the positioning when above the threshold
                  productDetailsContainer.style.position = '';
                  productDetailsContainer.style.top = '';
                  productDetailsContainer.style.bottom = '';
              }
          } 
      },
    
    initCarouselScrolling: function() {
        const {resourcesHeader, ymalHeader} = this;
        let scrollDistance = 375;
        const scrollDuration = 300;
        if (window.innerWidth < 476) {
            scrollDistance = 150;
        } else if (window.innerWidth < 571 && window.innerWidth > 475) {
            scrollDistance = 200;
        }
        if (resourcesHeader) {
            const resourcesContainer = document.querySelector('.resources-carousel');
            const resourcesArrows = resourcesHeader.querySelectorAll('.navigation-arrow');
            resourcesArrows.forEach((arrow) => {
                arrow.addEventListener('click', () => {
                const direction = arrow.id;
                if (direction.includes('left')) {
                    Utility.smoothScroll(resourcesContainer, -scrollDistance, scrollDuration);
                } else if (direction.includes('right')) {
                    Utility.smoothScroll(resourcesContainer, scrollDistance, scrollDuration);
                }
                });
            });
        }
        
        if (ymalHeader) {
            const ymalContainer = document.querySelector('.ymal-products');
            const ymalArrows = ymalHeader.querySelectorAll('.navigation-arrow');
            ymalArrows.forEach((arrow) => {
                arrow.addEventListener('click', () => {
                const direction = arrow.id;
                if (direction.includes('left')) {
                    Utility.smoothScroll(ymalContainer, -scrollDistance, scrollDuration);
                } else if (direction.includes('right')) {
                    Utility.smoothScroll(ymalContainer, scrollDistance, scrollDuration);
                }
                });
            });
        }
    },
    
    ampedProAirInit: function() {
      const {addToCartBtn, productData } = this;
      let parent = document.querySelector('.product-page-template');
      const selectedSwatch = parent.querySelector('.swatch-btn.selected');
      const swatchValue = selectedSwatch.dataset.swatchValue;
      if (productData.title.includes('Pro Air')) {
        let announcementBar = document.querySelector('.announcement-bg');
        announcementBar.style.backgroundColor = selectedSwatch.dataset.bgColor;
        addToCartBtn.style.backgroundColor = selectedSwatch.dataset.bgColor;
        const fbtProducts = document.querySelectorAll('.fbt-product-card');
        fbtProducts.forEach((product) => {
          const swatches = product.querySelectorAll('.swatch-fbt');
          let swatchToSelect = null;
          Array.from(swatches).forEach((swatch) => {
              if (swatch.dataset.swatchValue.includes(swatchValue)) {
                  swatchToSelect = swatch;
              } else if(swatchValue == 'Gray') {
                if (swatch.dataset.swatchValue.includes('Black')) {
                  swatchToSelect = swatch;
                }
              }
          });
          if (swatchToSelect) {
            swatchToSelect.click();
          }
        });
      }
    },

    updateReviewAggregate: function() {
      const reviewsNav = document.querySelector('.oke-w-controls');
      if (reviewsNav) {
        reviewsNav.querySelector('.oke-poweredBy').remove();
      }
      const reviewsNavOld = document.querySelector('#reviews-nav');
      if (reviewsNavOld && reviewsNav) {
        reviewsNavOld.replaceWith(reviewsNav);
      }

      const reviewBtn = document.querySelector('.oke-w-reviews-writeReview');
      const aggregateBars = document.querySelector('.oke-w-breakdownModule');
      if (reviewBtn && aggregateBars) {
        aggregateBars.appendChild(reviewBtn);
      }
    },
  
    displayReviewAggregate: async function(okendoGroupId, productId) {
      console.log('okdeno id', okendoGroupId);
      console.log('product id', productId);
        let url;
        if (okendoGroupId != '') {
            url = `/stores/e3a2fa3a-f5d5-403d-9f59-2b41d1ad8c1f/collections/${okendoGroupId}/review_aggregate`;
        } else {
            url = `/stores/e3a2fa3a-f5d5-403d-9f59-2b41d1ad8c1f/products/shopify-${productId}/review_aggregate`;
        }
        let reviewsData = await this.fetchReviewsData(url);
        if (!reviewsData) return;

        reviewsData = reviewsData.reviewAggregate;
      console.log('reviews data', reviewsData);

      console.log('reviews container', document.querySelector('.okeReviews-reviewsWidget'));

        const reviewsHeader = document.querySelector('.okeReviews-reviewsWidget-header');
      console.log('reviews header', reviewsHeader);
        const totalReviews = reviewsData.ratingAndReviewCount;
        if (totalReviews > 0) {
          console.log('total reviews > 0');
            const recommendedCount = reviewsData.recommendationCount;
            const recommendedPercentage = (recommendedCount / totalReviews * 100).toFixed(0);
            const aggregateContainer = document.createElement('div');
            aggregateContainer.classList.add('aggregate-container');
            this.aggregateContainer = aggregateContainer;
            this.averageRating = this.calculateAverageRating(reviewsData.ratingAndReviewCountByLevel);
            this.constructRatingBarsHtml(reviewsData.ratingAndReviewCountByLevel, totalReviews);
            this.constructReviewsSummaryHtml(totalReviews, recommendedPercentage);

            const reviewImgs = document.querySelector('.okeReviews-mediaAggregate');
            if (reviewImgs) {
                this.aggregateContainer.appendChild(reviewImgs);
            }
            
            reviewsHeader.before(aggregateContainer);

            const ratingBarsSect = document.querySelector('.rating-bars');
            const reviewBtn = document.querySelector('.okeReviews-reviewsWidget-header-controls-writeReview');
            ratingBarsSect.after(reviewBtn);

            this.reviewsSizeEventListener();
        }
    },
    
    calculateAverageRating: function(countPerRating) {
        //calculate avg rating
        const result = Object.entries(countPerRating).reduce((acc, [key, count]) => {
        // Extract the number part from the key, e.g., "level3Count" -> 3
        const levelMatch = key.match(/level(\d+)Count/);
        if (levelMatch) {
        const level = Number(levelMatch[1]); // Convert the extracted part to number
        acc.total += level * count;
        acc.count += count;
        }
        return acc;
    }, { total: 0, count: 0 });
        const averageRating = (result.total / result.count).toFixed(1);
        return averageRating;
    },
    
    constructRatingBarsHtml: function(countPerRating, totalReviews) {
        const {aggregateContainer} = this;
        const ratingBars = document.createElement('div');
        ratingBars.classList.add('rating-bars-container');
        ratingBars.innerHTML = `
        <p>Reviews/Ratings</p>
        <div class="rating-bars">
        ${Object.entries(countPerRating).reverse().map(([key, count]) => {
            const level = parseInt(key.match(/\d+/)[0]); // Extract the level number from the key
            return this.constructRatingBar(level, count, totalReviews);
        }).join('')}        
        </div>
        `;
        aggregateContainer.appendChild(ratingBars);
    },
    
    constructRatingBar: function(level, count, totalCount) {
        return `
        <div class="rating-bar">
            <div class="rating-level">${level}</div>
            <div class="bar-container">
            <div class="rating-bar-bg"></div>
            <div class="rating-bar-top" style="width:${count / totalCount * 100}%"></div>
            </div>
            <p class="rating-count">(${count})</p>
        </div>
        `;
    },
    
    constructReviewsSummaryHtml: function(totalReviews, recommendedPercentage) {
        const {aggregateContainer, averageRating} = this;
        const starsWidth = averageRating / 5 * 100;
        const reviewsSummary = document.createElement('div');
            reviewsSummary.classList.add('reviews-summary');
            reviewsSummary.innerHTML = `
            <div class="reviews-row">${averageRating}
            <div class="stars-container">
                <div class="stars-cover" style="width:${starsWidth.toFixed(0)}%;">
                <img src="https://cdn.shopify.com/s/files/1/0152/5763/2822/files/5_star_review.png?v=1708722417" class="stars-top stars" alt="${averageRating} stars">
                </div>
                <img src="https://cdn.shopify.com/s/files/1/0152/5763/2822/files/5_grey_stars.png?v=1710447125" class="stars-bg stars" alt="${averageRating} stars">
            </div>
            </div>
            <p class="reviews-p">Based on ${totalReviews} reviews</p>
            <p class="reviews-head">${recommendedPercentage}%</p>
            <p class="reviews-p">Recommended</p>
            `;
            aggregateContainer.appendChild(reviewsSummary);
    },
    
    reviewsSizeEventListener: function() {
        const reviewsSummary = document.querySelector('.reviews-summary');
        const ratingBars = document.querySelector('.rating-bars-container');
        if (window.innerWidth < 1200) {
            reviewsSummary.after(ratingBars);
        }
        window.addEventListener('resize', function() {
            if (window.innerWidth < 1200) {
                reviewsSummary.after(ratingBars);
            } else {
                ratingBars.after(reviewsSummary);
            }
        });
    },
    
    fetchReviewsData: async function(url) {
        const fetchUrl = `https://api.okendo.io/v1${url}`;
        try {
            const response = await fetch(fetchUrl);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Fetching reviews failed: ', error);
            return [];
        }
    }
};